import React from 'react';
import UmlShapeWidgetBase from './UmlShapeWidgetBase';
import { JxTooltip, JxTooltipRowItemDescription } from '@jx';
import './UmlCommentWidget.css';

// Pure painter for UmlCommentShape — PlantUML note element: dashed box with free
// text. No children/caption/members like Package/Class — just shape.text.
// Click-to-select + inline-edit (textarea, multiline) lives in UmlShapeWidgetBase.
class UmlCommentWidget extends UmlShapeWidgetBase {
    getMinSize() {
        return { width: 100, height: 60 };
    }

    getEditableZoneClassName() {
        return 'uml-comment-widget-text';
    }

    getEditableInputClassName() {
        return 'uml-comment-widget-text-input';
    }

    getEditableText() {
        return this.props.shape.text;
    }

    getEditableFieldType() {
        return 'textarea';
    }

    render() {
        const shape = this.props.shape;
        return (
            <JxTooltip followCursor title={<JxTooltipRowItemDescription label="Press D" value="Delete shape" />}>
                <div
                    className={`uml-comment-widget${this.props.isSelected ? ' uml-selected' : ''}`}
                    data-shape-id={shape.id}
                    style={{ left: shape.x, top: shape.y, width: shape.w, height: shape.h, zIndex: this.props.stackIndex ?? shape.zIndex }}
                    onMouseDown={this.handleDragMouseDown}
                >
                    {this.renderEditableZone(shape.text)}
                    {this.renderResizeHandles()}
                </div>
            </JxTooltip>
        );
    }
}

export default UmlCommentWidget;
